import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {Link} from "react-router-dom";

import {Container} from "components/misc/Layouts.js";
import Hero from "components/headers/light";
import Footer from "components/Footer";
import AdComponent from '../../../components/AdComponent.js'

import {useAppDispatch, loadActor, loadMoreActor, useAppSelector} from "../../../redux";
import ReadMoreButton from "components/ReadMoreButton.js";

const TabContent = tw(
  motion.div
)` mt-5 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-4 lg:grid-cols-5 lg:gap-6`;
const CardContainer = tw.div` w-full `;
const Card = tw(
  motion.a
)`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;
const CardImageContainer = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`h-56 md:h-56 lg:h-72 bg-center bg-cover relative rounded-t`}
`;

const ContentWithPaddingXl = tw.div`max-w-screen-xl min-h-screen mx-auto p-5 py-24`;
const CardText = tw.div`lg:p-4 md:p-2 p-1 text-gray-900`;
const CardTitle = tw.h5`text-lg font-semibold group-hover:text-yellow-800 text-gray-800 text-center`;
const Div = tw.div`w-full  mx-auto px-5 xsm:py-2 lg:py-4 z-50 fixed bg-white`;
const Header = tw.div`text-xl font-bold text-gray-900`;
const Hr = tw.hr`mt-2`
export default ({ heading = "Actor" }) => {

  const dispatch = useAppDispatch();
  const [footerShow, setFooterShow] = useState(true);

  const actor = useAppSelector(state => state.actor.actor);
  const isEndReached = useAppSelector(state => state.actor.isEndReached);


  useEffect(() => {
    if (actor.length === 0) {
      dispatch(loadActor());
    }
  }, [dispatch]);


  const handleLoadMoreData = () => {
    dispatch(loadMoreActor());
  }


  return (
    <Container>
      <Div>
        <Hero />
        <Hr/>
      </Div>

      <ContentWithPaddingXl>
        
        <Header>{heading}</Header>
       <AdComponent/> 
        <TabContent>
          {actor && actor.map((items,index) => (
            <CardContainer key={items.index}>
              <Card
                className="group"
                initial="rest"
                whileHover="hover"
                animate="rest"
              >
                <Link to={`/actors/${items.id}`}>
                  <CardImageContainer imageSrc={items.cover_url} />
                </Link>

                <CardText>
                  <CardTitle>{items.name}</CardTitle>
                </CardText>
              </Card>
            </CardContainer>
          ))}
        </TabContent>
        {isEndReached ? null : <ReadMoreButton handleLoadMoreData={handleLoadMoreData} />} 
      </ContentWithPaddingXl>
      {footerShow?  <Footer />: <></>}
     
    </Container>
  );
};
